import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-guide-two',
  templateUrl: './guide-two.component.html',
})
export class GuideTwoComponent {
  items = [
    { name: 'option1', label: 'Option 1' },
    { name: 'option2', label: 'Option 2' },
    { name: 'option3', label: 'Option 3' },
  ];
  brainstormForm: UntypedFormGroup = this.fb.group({
    name: this.fb.array([]),
  });

  constructor(private fb: UntypedFormBuilder, private router: Router) {}

  onSubmit() {
    this.router.navigate(['step-three']).then();
  }
}
